import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
// Invented purchase records (NOT derived from any user input).
// Each record: first name + last initial + a Mexican city.
const purchases = [{
  name: 'María L.',
  city: 'Monterrey'
}, {
  name: 'Andrea G.',
  city: 'CDMX'
}, {
  name: 'Lupita R.',
  city: 'Guadalajara'
}, {
  name: 'Carmen H.',
  city: 'Querétaro'
}, {
  name: 'Sofía M.',
  city: 'Puebla'
}, {
  name: 'Gabriela P.',
  city: 'León'
}, {
  name: 'Beatriz N.',
  city: 'Mérida'
}, {
  name: 'Patricia V.',
  city: 'Toluca'
}, {
  name: 'Daniela S.',
  city: 'Tijuana'
}, {
  name: 'Elena T.',
  city: 'Cancún'
}, {
  name: 'Verónica O.',
  city: 'Aguascalientes'
}, {
  name: 'Isabel R.',
  city: 'Hermosillo'
}, {
  name: 'Adriana C.',
  city: 'Saltillo'
}, {
  name: 'Mónica B.',
  city: 'Morelia'
}, {
  name: 'Claudia F.',
  city: 'San Luis Potosí'
}, {
  name: 'Norma J.',
  city: 'Chihuahua'
}, {
  name: 'Rosa E.',
  city: 'Cuernavaca'
}, {
  name: 'Lucía A.',
  city: 'Veracruz'
}, {
  name: 'Teresa V.',
  city: 'Oaxaca'
}, {
  name: 'Esperanza D.',
  city: 'Pachuca'
}];
const INITIAL_DELAY_MS = 3000;
const VISIBLE_MS = 5000;
const HIDDEN_MS = 5000;
export const SocialProofToast: React.FC = () => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  // Pick a random purchase index that differs from the current one so the
  // same name never appears two times in a row.
  const pickRandomIndex = (current: number) => {
    if (purchases.length <= 1) return 0;
    let next = Math.floor(Math.random() * purchases.length);
    while (next === current) {
      next = Math.floor(Math.random() * purchases.length);
    }
    return next;
  };
  // First appearance — random name + random "minutes ago"
  useEffect(() => {
    const t = window.setTimeout(() => {
      setIndex(Math.floor(Math.random() * purchases.length));
      setMinutesAgo(Math.floor(Math.random() * 9) + 1);
      setVisible(true);
      setHasStarted(true);
    }, INITIAL_DELAY_MS);
    return () => window.clearTimeout(t);
  }, []);
  // Cycle between visible and hidden states. Each transition owns its OWN
  // timeout, so cleanup never accidentally cancels the next scheduled flip.
  useEffect(() => {
    if (!hasStarted) return;
    if (visible) {
      // Currently visible — schedule the hide
      const hide = window.setTimeout(() => setVisible(false), VISIBLE_MS);
      return () => window.clearTimeout(hide);
    } else {
      // Currently hidden — schedule the next purchase to appear
      const show = window.setTimeout(() => {
        setIndex(i => pickRandomIndex(i));
        setMinutesAgo(Math.floor(Math.random() * 9) + 1);
        setVisible(true);
      }, HIDDEN_MS);
      return () => window.clearTimeout(show);
    }
  }, [visible, hasStarted]);
  const purchase = purchases[index];
  return <div className="fixed bottom-4 left-4 z-[60] pointer-events-none max-w-[280px] md:max-w-[320px]" data-id="element-295">
      <AnimatePresence mode="wait" data-id="element-296">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        x: -24,
        y: 12
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -24,
        transition: {
          duration: 0.3
        }
      }} transition={{
        duration: 0.45,
        ease: 'easeOut'
      }} className="pointer-events-auto bg-white rounded-xl shadow-2xl border border-[#E8E2D5] p-3 pr-4 flex items-start gap-3" data-id="element-297">
            <div className="shrink-0 w-9 h-9 rounded-full bg-mint-green flex items-center justify-center" data-id="element-298">
              <CheckCircle2 className="w-5 h-5 text-forest-green" data-id="element-299" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-300">
              <p className="text-[13px] text-dark-text leading-tight" data-id="element-301">
                <span className="font-bold" data-id="element-302">{purchase.name}</span> de{' '}
                <span className="font-semibold" data-id="element-303">{purchase.city}</span>
              </p>
              <p className="text-[12px] text-muted-text leading-tight mt-0.5" data-id="element-304">
                acaba de obtener El Protocolo
              </p>
              <p className="text-[11px] text-forest-green/70 font-medium mt-1" data-id="element-305">
                Hace {minutesAgo} min · Compra verificada
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};